'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _emailStyleTools = require('helpers/emailStyleTools');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function JourneyHeader(props) {
  var from = props.from,
      to = props.to,
      duration = props.duration,
      components = props.components,
      departure = props.departure;

  var styleCities = (0, _emailStyleTools.containerStyles)(components, 'Cities');
  var styleSegmentCities = (0, _emailStyleTools.textStyles)(components, 'Segment_Cities');
  var styleTime = (0, _emailStyleTools.textStyles)(components, 'Time');

  return _react2.default.createElement(
    'table',
    { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'JourneyHeader' },
    _react2.default.createElement(
      'tbody',
      null,
      _react2.default.createElement(
        'tr',
        null,
        _react2.default.createElement(
          'td',
          { style: (0, _extends3.default)({}, styleCities, { padding: '10px' }) },
          _react2.default.createElement(
            'table',
            { style: { borderCollapse: 'collapse', width: '100%' }, 'data-component': 'JourneyHeader_Sub' },
            _react2.default.createElement(
              'tbody',
              null,
              _react2.default.createElement(
                'tr',
                null,
                _react2.default.createElement(
                  'td',
                  { style: { padding: '0', width: '70%' } },
                  _react2.default.createElement(
                    'span',
                    { style: styleSegmentCities },
                    from,
                    ' ',
                    '>',
                    ' ',
                    to
                  )
                ),
                duration && _react2.default.createElement(
                  'td',
                  { style: { padding: '0', width: '30%', textAlign: 'right' } },
                  _react2.default.createElement(
                    'span',
                    { style: styleTime },
                    duration
                  )
                ),
                departure && _react2.default.createElement(
                  'td',
                  { style: { padding: '0', width: '30%', textAlign: 'right' } },
                  _react2.default.createElement(
                    'span',
                    { style: styleTime },
                    departure
                  )
                )
              )
            )
          )
        )
      )
    )
  );
}

var mstp = function mstp(state) {
  return {
    components: state.templateApplication.templates.currentTemplate.components
  };
};

exports.default = (0, _reactRedux.connect)(mstp)(JourneyHeader);
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/TemplateComponents/Air/Email/JourneyHeader.jsx
// module id = 650
// module chunks = 0